// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:Vazir;src:url(/fonts/Vazir-Regular.ttf);font-weight:100;font-style:normal}@font-face{font-family:NotoSansArabic;src:url(/fonts/NotoSansArabic-Regular.ttf);font-weight:100;font-style:normal;font-display:swap}@font-face{font-family:Ephesis;src:url(/fonts/Ephesis-Regular.ttf);font-weight:100;font-style:normal;font-display:swap}@font-face{font-family:Ranchers;src:url(/public/fonts/Ranchers-Regular.ttf);font-weight:100;font-style:normal;font-display:swap}", ""]);
// Exports
module.exports = exports;
